import React, { useEffect } from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-policy-page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <div className="privacy-content">
          <p><strong>Effective Date: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</strong></p>

          <h2>1. Information We Collect</h2>
          <p>We may collect personal information such as your name, email address, phone number, and medical history when you book an appointment or contact us. This helps us provide you with the best possible care.</p>

          <h2>2. How We Use Your Information</h2>
          <p>We use your information to provide medical services, communicate with you about your appointments, improve our services, and send you relevant updates or offers if you have subscribed to our newsletter.</p>

          <h2>3. Data Protection</h2>
          <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Patient confidentiality is our utmost priority.</p>

          <h2>4. Sharing of Information</h2>
          <p>We do not sell or rent your personal information to third parties. We may share information with trusted partners who assist us in operating our clinic, as long as those parties agree to keep this information strictly confidential.</p>

          <h2>5. Your Rights</h2>
          <p>You have the right to access, correct, or request deletion of your personal data. Please contact us to exercise these rights, and we will promptly address your request.</p>

          <h2>6. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically.</p>

          <h2>7. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy or how we handle your data, please contact us at:</p>
          <div className="contact-details">
            <p><strong>Dr Vaibhav Moghariya Clinic</strong></p>
            <p>Behind Axis Bank, Bus Station Road<br />Surendranagar, Gujarat 363002</p>
            <p>Email: vaibhavmoghariya1209@gmail.com<br />
              Phone: +91 79843 64765</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
